export const difference = <T>(a: Set<T>, b: Set<T>): Set<T> => {
    try {
        return a.difference(b);
    } catch {
        const difference = new Set<T>(a);
        for (const o of b) {
            difference.delete(o);
        }
        return difference;
    }
};

export const symmetricDifference = <T>(setA: Set<T>, setB: Set<T>) => {
    try {
        return setA.symmetricDifference(setB);
    } catch {
        const _difference = new Set(setA);
        for (const elem of setB) {
            if (_difference.has(elem)) {
                _difference.delete(elem);
            } else {
                _difference.add(elem);
            }
        }
        return _difference;
    }
};

export const hasSymmetricDifference = <T>(setA: Set<T>, setB: Set<T>) => {
    const _difference = new Set(setA);
    for (const elem of setB) {
        if (_difference.has(elem)) {
            _difference.delete(elem);
        } else {
            return true;
        }
    }
    return _difference.size > 0;
};
